import { Button, Tooltip } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import React, { useState, useEffect } from 'react'
import { IntegrationProjects } from 'src/core/models'
import { EyeOutlined, ShareAltOutlined } from '@ant-design/icons'
import styles from './IntegrationProjectsActionsColumn.module.scss'
import IntegrationToShareProjectModal from '../ShareProjectModal/IntegrationToShareProjectModal'
import IntegrationProjectDetailsModal from './IntegrationProjectDetailsModal/IntegrationProjectDetailsModal'

export const IntegrationProjectsActionsColumn: React.FC<{ project: IntegrationProjects }> = (props) => {
  const { project } = props
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isButtonVisible, setIsButtonVisible] = useState(false)
  const [isDetailsModalVisible, setIsDetailsModalVisible] = useState(false)
  const { width } = useWindowSize()
  useEffect(() => { setIsButtonVisible(width <= 800) }, [width])

  return <>
    <Button
      icon={<ShareAltOutlined />}
      className={styles['action-button']}
      onClick={() => setIsModalVisible(true)}
    >
      {t('developers.Share')}
    </Button>

    {isButtonVisible && (
      <Tooltip title={t('Transactions.CheckProjectDetails')} color={'blue'}>
        <Button
          type='default'
          shape='circle'
          className='radius-100 mt-2'
          onClick={() => setIsDetailsModalVisible(true)}
          icon={<EyeOutlined />}
        />
      </Tooltip>
    )}

    <IntegrationProjectDetailsModal
      isModalVisible={isDetailsModalVisible}
      handleCancel={() => setIsDetailsModalVisible(false)}
      project={project}
    />

    <IntegrationToShareProjectModal
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      project_id={project.id}
      projectName={project.name}
    />
  </>
}

export default IntegrationProjectsActionsColumn
